import * as React from 'react';

import { createIcon } from '../Icon';
export const TrelloIcon = createIcon(
  <React.Fragment>
    <rect height={18} rx={2} ry={2} width={18} x={3} y={3} />
    <rect height={9} width={3} x={7} y={7} />
    <rect height={5} width={3} x={14} y={7} />
  </React.Fragment>,
  'TrelloIcon'
);
